function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "menu",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, React.createElement("g", {
  id: "screen-with-menu",
  transform: "translate(-304.000000, -13.000000)",
  stroke: "#000840",
  strokeWidth: 1.5
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(305.000000, 12.000000)"
}, React.createElement("g", {
  id: "Group-7",
  transform: "translate(0.000000, 2.000000)"
}, React.createElement("path", {
  d: "M0,0.5 L8.93840945,0.5",
  id: "Line"
}), React.createElement("path", {
  d: "M0,4.5 L8.93840945,4.5",
  id: "Line"
}), React.createElement("path", {
  d: "M0,8.5 L8.93840945,8.5",
  id: "Line"
})))));

var SvgIconMenu = function SvgIconMenu(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-menu.da2de34b.svg";
export { ForwardRef as ReactComponent };